import styled from '@emotion/styled';

import vars from 'theme/styles/vars';

export default styled.section`
    text-align: center;
    line-height: 1.2;

    .layout-container {
        .hero-header-headline {
            max-width: 1000px;
        }

        .hero-header-subheadline {
            display: none;
        }
    }
`;
